const initialState = 1;

const phonesPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_PHONES_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default phonesPaginationReducer;